import { render } from "./the-you-tube.vue?vue&type=template&id=0a5fc534&scoped=true"
import script from "./the-you-tube.vue?vue&type=script&lang=js"
export * from "./the-you-tube.vue?vue&type=script&lang=js"

import "./the-you-tube.vue?vue&type=style&index=0&id=0a5fc534&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5fc534"]])

export default __exports__